import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Button,
  ListGroup,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import { API_URL } from "../../../Constant";
import { Calendar } from "react-multi-date-picker";
import CounsellorNavbar from "../../Counsellor/CounsellorLayout/CounsellorNavbar";
import CounsellorFooter from "../../Counsellor/CounsellorLayout/CounsellorFooter";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import ClientNavbar from "../ClientLayout/ClientNavbar";
import ClientFooter from "../ClientLayout/ClientFooter";
import { BiFontSize } from "react-icons/bi";
import { ImFontSize } from "react-icons/im";
import "../../Client/Client.css";
const BookAppointment = () => {
  const { counsellorId } = useParams();
  const navigate = useNavigate();

  const [counsellorList, setCounsellorList] = useState([]);
  const [counsellorName, setcounsellorName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [countryName, setCountryName] = useState("");
  const [stateName, setStateName] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [ethinicity, setEthinicity] = useState("");
  const [religion, setReligion] = useState("");
  const [language, setLanguage] = useState("");
  const [expertise, setExpertise] = useState("");
  const [masterDegree, setMasterDegree] = useState("");
  const [mdUniversity, setMdUniversity] = useState("");
  const [mdPassingYear, setMdPassingYear] = useState("");
  const [graduationDegree, setGraduationDegree] = useState("");
  const [gdUniversity, setGdUniversity] = useState("");
  const [gdPassingYear, setGdPassingYear] = useState("");
  const [otherQualification, setOtherQualification] = useState("");
  const [resumeFileUrl, setResumeFileUrl] = useState("");
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [bio, setBio] = useState("");
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [age, setAge] = useState("");

  const [selectedDate, setSelectedDate] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const [monthYear, setMonthYear] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${(now.getMonth() + 1)
      .toString()
      .padStart(2, "0")}`;
  });

  // Fetch monthly availability for the given counselor and monthYear.
  useEffect(() => {
    const fetchCalendarAvailability = async () => {
      try {
        const response = await fetch(
          `${API_URL}api/availability/calendar/${counsellorId}?monthYear=${monthYear}`
        );
        const data = await response.json();
        setCalendarData(data);
      } catch (error) {
        console.error("Error fetching calendar availability:", error);
      }
    };
    handleGetDetails();
    fetchCalendarAvailability();
  }, [monthYear, counsellorId]);

  const handleGetDetails = async () => {
    const apiUrl = `${API_URL}api/Counsellor/GetCounsellorListByCounsellerId/${counsellorId}`;
    console.log("API URL:", apiUrl); // Check if the URL is correct

    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Counsellor Details:", data);

      if (data && Array.isArray(data.data)) {
        const counsellor = data.data[0];
        setCounsellorList(data.data);
        setcounsellorName(counsellor.counsellorName);
        setDateOfBirth(counsellor.dateOfBirth);
        setGender(counsellor.gender);
        setMaritalStatus(counsellor.maritalStatus);
        setCountryName(counsellor.countryName);
        setStateName(counsellor.stateName);
        setAddress(counsellor.address);
        setPincode(counsellor.pincode);
        setEthinicity(counsellor.ethinicity);
        setReligion(counsellor.religion);
        setLanguage(counsellor.language);
        setExpertise(counsellor.expertise);
        setMasterDegree(counsellor.masterDegree);
        setMdUniversity(counsellor.mdUniversity);
        setMdPassingYear(counsellor.mdPassingYear);
        setGraduationDegree(counsellor.graduationDegree);
        setGdUniversity(counsellor.gdUniversity);
        setGdPassingYear(counsellor.gdPassingYear);
        setOtherQualification(counsellor.otherQualification);
        setResumeFileUrl(counsellor.resumeFileUrl);
        setYearsOfExperience(counsellor.yearsOfExperience);
        setBio(counsellor.bio);
        setProfilePictureUrl(counsellor.profilePictureUrl);

        calculateAge(counsellor.dateOfBirth);
        // setCounsellorLoginId(counsellor.loginId);
      } else {
        console.error("Invalid API response format:", data);
      }
    } catch (error) {
      console.error("Error fetching Counsellor Details:", error);
    }
  };

  const calculateAge = (birthdateStr) => {
    const birthdate = new Date(birthdateStr);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthdate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthdate.getMonth();
    const dayDifference = currentDate.getDate() - birthdate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--; // Adjust if the birthday hasn't occurred yet this year
    }

    setAge(age);
  };
  // On calendarData update, if no date is selected, choose today's date or first available future date.
  useEffect(() => {
    if (calendarData.length > 0 && !selectedDate) {
      const today = new Date();
      const todayStr = today.toISOString().slice(0, 10);
      // Filter available dates that are today or in the future.
      const availableDates = calendarData
        .filter((item) => {
          if (item.timeSlots && item.timeSlots.length > 0) {
            const itemDate = new Date(item.date);
            return itemDate >= new Date(todayStr);
          }
          return false;
        })
        .map((item) => item.date);
      if (availableDates.includes(todayStr)) {
        setSelectedDate(todayStr);
      } else if (availableDates.length > 0) {
        // Choose the first available future date
        const firstAvailable = availableDates.sort()[0];
        setSelectedDate(firstAvailable);
      }
    }
  }, [calendarData, selectedDate]);

  // When a date is selected, fetch available slots for that day.
  useEffect(() => {
    const fetchSlots = async () => {
      if (selectedDate) {
        const dateStr =
          typeof selectedDate === "string"
            ? selectedDate
            : selectedDate.format("YYYY-MM-DD");
        try {
          const response = await fetch(
            `${API_URL}api/availability/slots/counselor/${counsellorId}?date=${dateStr}`
          );
          const data = await response.json();
          setAvailableSlots(data.availableSlots || []);
        } catch (error) {
          console.error("Error fetching slots for selected date:", error);
        }
      }
    };
    fetchSlots();
  }, [selectedDate, counsellorId]);

  // Handle month change: newDate is a DateObject from react-multi-date-picker.
  const handleMonthChange = (newDate) => {
    const dateObj = newDate.toDate();
    const newMonthYear = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1)
      .toString()
      .padStart(2, "0")}`;
    setMonthYear(newMonthYear);
  };

  // Custom onChange: only allow selecting a date if it is available.
  const handleDateChange = (value) => {
    const dateStr =
      typeof value === "string" ? value : value.format("YYYY-MM-DD");
    // Filter available dates that are today or in the future.
    const today = new Date().toISOString().slice(0, 10);
    const availableDates = calendarData
      .filter(
        (item) =>
          item.timeSlots &&
          item.timeSlots.length > 0 &&
          new Date(item.date) >= new Date(today)
      )
      .map((item) => item.date);
    if (availableDates.includes(dateStr)) {
      setSelectedDate(value);
    }
  };

  // Disable day: disable dates if they're in the past or not available.
  const disableDay = ({ date }) => {
    const jsDate = date.toDate();
    const today = new Date();
    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    if (jsDate < todayStart) return true;
    const dateStr = date.format("YYYY-MM-DD");
    const availableDates = calendarData
      .filter(
        (item) =>
          item.timeSlots &&
          item.timeSlots.length > 0 &&
          new Date(item.date) >= todayStart
      )
      .map((item) => item.date);
    return !availableDates.includes(dateStr);
  };

  // mapDays: highlight only available dates (today or in the future).
  const mapDays = ({ date }) => {
    const jsDate = date.toDate();
    const today = new Date();
    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    if (jsDate < todayStart) {
      return {};
    }
    const dateStr = date.format("YYYY-MM-DD");
    const availableDates = calendarData
      .filter(
        (item) =>
          item.timeSlots &&
          item.timeSlots.length > 0 &&
          new Date(item.date) >= todayStart
      )
      .map((item) => item.date);
    if (availableDates.includes(dateStr)) {
      return {
        style: { backgroundColor: "#d9dedb" },
      };
    }
    return {};
  };

  // Handler for booking a slot
  const handleBookSlot = (slot) => {
    console.log("Booking slot:", slot);
    const slotdate =
      typeof selectedDate === "string"
        ? selectedDate
        : selectedDate.format("DD-MM-YYYY");
    navigate("/client/ConfirmAndPay", {
      state: {
        counsellorName,
        counsellorId,
        selectedSlotDate: slotdate,
        slotTime: slot,
      },
    });
  };

  return (
    <>
      <ClientNavbar />
      <Container className="mt-4 mb-4 pb-4">
        <Row>
          {/* Cards Column */}
          <Col md={4}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                flexWrap: "nowrap", // Prevent wrapping to next row
                textAlign: "center",
              }}
            >
              {counsellorList.map((counsellor, index) => (
                <div
                  key={index}
                  className="card"
                  style={{
                    width: "20rem",
                    height: "25.5rem", // Same height for consistency
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {/* Header Section */}
                  <div className="row" style={{ padding: "25px" }}>
                    <div
                      className="col-md-4"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={`${API_URL}api/Login/GetImageByImageURL/${counsellor.profilePictureUrl.replace(
                          "images/",
                          ""
                        )}`}
                        alt="User"
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "50%",
                          border: "2px solid rgb(180, 199, 219)",
                        }}
                        onError={(e) => {
                          console.log("Image load error:", e);
                          e.target.onerror = null;
                        }}
                      />
                    </div>

                    <div
                      className="col-md-8"
                      style={{
                        textAlign: "left",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        color: "#333",
                      }}
                    >
                      {counsellor.counsellorName}
                    </div>
                  </div>

                  <div className="card-body">
                    <strong style={{ color: "#555" }}>Expertise:</strong>{" "}
                    <span style={{ color: "#288ffd", fontWeight: "500" }}>
                      {counsellor.expertise}
                    </span>
                    <br />
                    <strong style={{ color: "#555" }}>Languages:</strong>{" "}
                    <span style={{ color: "#288ffd", fontWeight: "500" }}>
                      {counsellor.language}
                    </span>
                    <br />
                    <br />
                    <span>
                      <strong style={{ color: "#555" }}>Duration:</strong> 60
                      Min
                    </span>
                    <br />
                    <span>
                      <strong style={{ color: "#555" }}>Fees:</strong> $0
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </Col>

          {/* Calendar Column */}
          <Col md={4}>
            <div
              className="card"
              style={{
                padding: "15px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                backgroundColor: "#ffffff",
                height: "25.5rem",
                overflowX: "auto", // Enable scrolling on smaller screens
              }}
            >
              <>
              <h6 style={{ color: "#288ffd", marginBottom: "15px" }}>
                Select a Date<br/>
              </h6>
              <div className="responsive-calendar">
                <Calendar
                  multiple={false}
                  value={selectedDate}
                  onChange={handleDateChange}
                  format="YYYY-MM-DD"
                  mapDays={mapDays}
                  onMonthChange={handleMonthChange}
                  disableDay={disableDay}
                  style={{
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: "#fff",
                    maxWidth: "100%", // Prevent overflow
                  }}
                />
              </div>
              </>
            </div>
          </Col>

          {/* Slots Column */}
          <Col md={4}>
            <div
              className="card"
              style={{
                padding: "15px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                backgroundColor: "#ffffff",
                height: "25.5rem",
                overflowY: "auto", // In case of many slots
              }}
            >
              {selectedDate && (
                <>
                  <h6 style={{ color: "#288ffd", marginBottom: "15px" }}>
                    Available Slots on{" "}
                    {typeof selectedDate === "string"
                      ? selectedDate
                      : selectedDate.format("YYYY-MM-DD")}
                  </h6>
                  {availableSlots.length > 0 ? (
                    <ListGroup>
                      {availableSlots.map((slot, index) => (
                        <ListGroup.Item
                          key={index}
                          className="d-flex justify-content-between align-items-center"
                          style={{
                            backgroundColor: "#f9f9f9",
                            border: "1px solid #eee",
                            borderRadius: "8px",
                            padding: "10px 15px",
                            marginBottom: "5px",
                          }}
                        >
                          <span>{slot}</span>
                          <Button
                            variant="primary"
                            size="sm"
                            style={{
                              backgroundColor: "#288ffd",
                              border: "none",
                              transition: "background-color 0.3s",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.backgroundColor = "#1b6fcc")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.backgroundColor = "#288ffd")
                            }
                            onClick={() => handleBookSlot(slot)}
                          >
                            Select Slot
                          </Button>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : (
                    <p style={{ color: "#777", fontSize: "0.9rem" }}>
                      No available slots on this date.
                    </p>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>

        <div style={{ textAlign: "center" }} className="mt-4">
          <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
            Previous
          </Button>
        </div>
      </Container>
      <ClientFooter />
    </>
  );
};

export default BookAppointment;
